var chunkToChildrenMap = {
	"1852": [
		585
	],
	"2097": [
		585
	],
	"5849": [
		585
	],
	"6472": [
		585
	],
	"6522": [
		9886,
		1177,
		3351
	],
	"7178": [
		585
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));